/* Banking Information — the rules, transcribed.
 *
 * From Financial/BankingInformation.jsx, Financial/AddBankingForm.jsx and
 * Financial/BankingDetail.jsx.
 */

/* The keys the merge needs, in this section's own naming. Shared shape with
   the people and relation specs — see sectionDrafts.js. */
export const BANK_SPEC = {
  key: "bank",
  companyListKey: "bankDetails",
  joinKey: "bankID",
  idKey: "bankID",
  draftIdKey: "bank_draftID",
  draftLinkKey: "bankID_id",

  createRequestType: "Bank Details create draft request",
  updateRequestType: "Bank update draft request",
  followCreated: "New Bank Added",
  followUpdated: "Bank Information Updated",
  deleteMessage: "Bank Information Deleted Successfully",
};

/* Transcribed from createArrayFromObject's whitelist and its order:
   ["bank_name", "IBAN", "country"]. */
export const BANK_ROWS = [
  { key: "bank_name", label: "Bank Name" },
  { key: "IBAN", label: "IBAN" },
  { key: "country", label: "Country" },
];

/* Transcribed: the IBAN is stored and shown uppercased — BankingDetail uppercases it on the way in (`bankInfo?.IBAN.toUpperCase()`) and again on the way out... */
export const bankRowValues = (record = {}) => ({
  bank_name: record?.bank_name || "",
  IBAN: String(record?.IBAN || "").toUpperCase(),
  country: record?.country || "",
});

/* What the IBAN lookup gives back, mapped to the three fields the form holds. */
export const bankFromLookup = (response) => {
  const data = response?.data;
  if (!data) return null;
  return {
    IBAN: String(data?.id || "").toUpperCase(),
    bank_name: data?.swift?.bank?.name || "",
    country: data?.country?.name || "",
  };
};

/* Transcribed: `handleDetail` only accepts a response carrying `data.data`,
   so a 200 with an empty body is treated as "no match" rather than a bank. */
export const lookupMatched = (result) => Boolean(result?.data?.data);

/* An IBAN is required before the lookup will run — the live `handleDetail` returns early on a falsy one. */
export const validateIban = (iban) => {
  const trimmed = String(iban ?? "").trim();
  if (trimmed === "") return "IBAN is required.";
  return "";
};
